import { showCustomerService } from "@/components/vendors";
import Error from "./errors";

export default function MembershipLimitReached() {
  return (
    <Error
      title="Membership Limit Reached"
      description="You are already a member of another account and cannot join this one."
      actionText="Access Application"
      actionHref="/"
    >
      <p className="mb-10 text-sm text-gray-700">
        If you need assistance, please{" "}
        <a onClick={showCustomerService} className="underline">
          contact us.
        </a>
      </p>
    </Error>
  );
}
